import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Sparkles, Send, Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function AIAssistant({ open, onOpenChange }) {
  const [messages, setMessages] = useState([
    { role: "ai", text: "Hi! I'm LaunchDeck Copilot. Ask me to draft a campaign, suggest social posts, analyze a competitor, or anything marketing." }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [sessionId] = useState(`s-${Date.now()}`);

  const send = async () => {
    const msg = input.trim();
    if (!msg || loading) return;
    setMessages((m) => [...m, { role: "user", text: msg }]);
    setInput("");
    setLoading(true);
    try {
      const { data } = await api.post("/ai/chat", { message: msg, session_id: sessionId });
      setMessages((m) => [...m, { role: "ai", text: data.response }]);
    } catch (e) {
      const msg = e?.response?.data?.detail || "Sorry — I hit an error. Please retry.";
      setMessages((m) => [...m, { role: "ai", text: msg }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-[440px] sm:max-w-md p-0 flex flex-col" data-testid="ai-assistant-panel">
        <SheetHeader className="p-5 border-b border-slate-200">
          <SheetTitle className="flex items-center gap-2">
            <Sparkles className="w-4 h-4 text-[#0044FF]" />
            <span className="display text-lg">AI Copilot</span>
          </SheetTitle>
          <SheetDescription className="text-xs text-slate-500">Powered by Gemini · ask me anything marketing</SheetDescription>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto p-5 space-y-3">
          {messages.map((m, i) => (
            <div
              key={i}
              className={`rounded-lg p-3 text-sm leading-relaxed ${
                m.role === "ai"
                  ? "glass-blue text-slate-800"
                  : "bg-slate-900 text-white ml-8"
              }`}
            >
              {m.text}
            </div>
          ))}
          {loading && (
            <div className="glass-blue rounded-lg p-3 flex items-center gap-2 text-sm text-slate-600">
              <Loader2 className="w-4 h-4 animate-spin" /> Thinking…
            </div>
          )}
        </div>
        <div className="p-4 border-t border-slate-200 flex gap-2">
          <Input
            data-testid="ai-chat-input"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && send()}
            placeholder="Ask anything…"
          />
          <Button
            data-testid="ai-chat-send"
            onClick={send}
            disabled={loading}
            className="bg-[#0044FF] hover:bg-[#0033CC]"
          >
            <Send className="w-4 h-4" />
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
